// extracted by mini-css-extract-plugin
export default {"wrapper":"constructor_wrapper__9HMNB","title":"constructor_title__dotM5"};